<script setup lang="ts">
  import { useScreenSize } from '@/shared/lib'

  import { DefaultLayoutHeader, DefaultLayoutSidebar } from '@/widgets/layout'

  const { fromDesktopMedium, isMobile } = storeToRefs(useScreenSize())

  const showSidebar = ref(true)
  const setOverflow = (value: boolean) => {
    document.body.style.overflow = value ? 'hidden' : 'visible'
    document.body.style.height = value ? '100vh' : 'auto'
  }
  const handleToggleSidebar = () => {
    if (!fromDesktopMedium.value) {
      showSidebar.value = !showSidebar.value
    }

    if (isMobile.value) {
      setOverflow(showSidebar.value)
    }
  }

  watch(
    () => fromDesktopMedium.value,
    (value) => (showSidebar.value = value),
    { immediate: true },
  )

  watchEffect(() => {
    if (!isMobile.value) {
      setOverflow(false)
    }
  })
</script>

<template>
  <div class="bg-surface-bg box-border flex flex-col items-center justify-start">
    <DefaultLayoutHeader
      v-model="showSidebar"
      @toggle-burger="handleToggleSidebar"
    />
    <div class="flex w-full flex-row items-stretch justify-center">
      <DefaultLayoutSidebar
        v-if="showSidebar"
        class="desktop-1660:ml-page-wrapper desktop-1920:ml-page-wrapper-wide"
        @close-sidebar="handleToggleSidebar"
      />

      <!-- Main page content -->
      <div
        class="max-desktop-medium:w-full max-mobile:flex max-mobile:flex-col max-mobile:justify-start max-mobile:items-center max-mobile:p-4 bg-surface-bg border-l-border min-h-screen-content z-2 flex-1"
      >
        <NScrollbar class="max-h-screen-content">
          <slot name="default" />
        </NScrollbar>
      </div>
    </div>
  </div>
</template>
